import Vue from 'vue';
const uuidv4 = require('uuid/v4');
import { ecommerce } from 'vue-analytics'
import StaticData from './../js/StaticData'

const companyName = process.env.VUE_APP_BT_COMPANY_NAME

export const couponCode = (state, {code, maxPax}) => {
  state.form.coupon = code;
  state.couponMaxPax = maxPax;
}

export const placeByType = (state, {id, placeType, description}) => {
  if (placeType === 'from') {
    state.fromPlace.placeId = id;
    state.fromPlace.description = description;
  } else if (placeType === 'to') {//mix match placeType ignored...
    state.toPlace.placeId = id;
    state.toPlace.description = description;
  }
}

export const toogleSessionTokenByType =  (state, placeType) => {
  if (placeType === 'from') {
    state.fromPlace.googleApiSessionToken = uuidv4();
  } else if (placeType === 'to') {//mix match placeType ignored...
    state.toPlace.googleApiSessionToken = uuidv4();
  }
}

export const settings = (state, obj) => {
  state.settings = obj;
  state.hasSetting = true;
  state.form.currency = obj.defaultCurrency;
  const staticData = companyName && StaticData[companyName];
  if (staticData) {
    state.staticCompanySettings = staticData;
  }
}

export const currency = (state, currency) => {
  state.form.currency = currency;
}

export const tripType = (state, tripType) => {
  state.tripType = tripType;
}

export const formFrom = (state, from) => {
  state.form.from = formatePlaceDetails(from);
}

export const formTo = (state, to) => {
  state.form.to = formatePlaceDetails(to);
}

export const formAdults = (state, adults) => {
  state.form.adults = adults;
}

export const formKids = (state, kids) => {
  state.form.kids = kids;
}

export const formServiceType = (state, {id, trip}) => {
  state.form.serviceTypeID = id;
  state.form.tripType = trip;
}

export const extrasById = (state, {extra, trip, quantity}) => {
  const key = extra.id+'-'+trip;
  if (quantity === 0) {
    Vue.delete(state.extrasByIdTrip, key);
  } else {
    state.extrasByIdTrip = {...state.extrasByIdTrip, [key]: {id: extra.id, trip, quantity, price: extra.price, name: extra.name}};
  }
}

export const formExtras = (state, extras) => {
  state.form = {...state.form, extras}
}

export const formFirstName = (state, firstName) => {
  state.form.clientFirstName = firstName;
}

export const formLastName = (state, lastName) => {
  state.form.clientLastName = lastName;
}

export const formEmail = (state, email) => {
  state.form.clientEmail = email;
}

export const formPhone = (state, phone) => {
  state.form.clientPhone = phone;
}

export const formNotes = (state, notes) => {
  state.form.clientNotes = notes;
}

export const formArrivalFligthNumber = (state, fligthNumber) => {
  state.form.arrivalFlightNumber = fligthNumber;
}

export const formArrivalAirline = (state, airline) => {
  state.form.arrivalAirline = airline;
}

export const formArrivalFlightTime = (state, fligthTime) => {
  state.form.arrivalFlightTime = fligthTime;
}

export const formDepartureFligthNumber = (state, fligthNumber) => {
  state.form.departureFlightNumber = fligthNumber;
}

export const formDepartureAirline = (state, airline) => {
  state.form.departureAirline = airline;
}

export const formDepartureFlightTime = (state, fligthTime) => {
  state.form.departureFlightTime = fligthTime;
}

export const formOriginPickupTime = (state, time) => {
  state.form.originPickUpTime = time;
}

export const formDestinationPickUpTime = (state, time) => {
  state.form.destinationPickUpTime = time;
}

export const formPickUpTime = (state, time) => {
  state.form.pickUpTime = time;
}

export const formPaymentMethod = (state, paymentMethod) => {
  state.form.paymentMethod = paymentMethod;
}

export const formDatesArrivalDate = (state, date) => {
  state.formDates.arrivalDate = date;
}

export const formDatesArrivalHours = (state, hours) => {
  state.formDates.arrivalHours = hours;
}

export const formDatesArrivalMinutes = (state, minutes) => {
  state.formDates.arrivalMinutes = minutes;
}

export const formDatesDepartureDate = (state, date) => {
  state.formDates.departureDate = date;
}

export const formDatesDepartureHours = (state, hours) => {
  state.formDates.departureHours = hours;
}

export const formDatesDepartureMinutes = (state, minutes) => {
  state.formDates.departureMinutes = minutes;
}

export const formDatesOriginDate = (state, date) => {
  state.formDates.originDate = date;
}

export const formDatesOriginHours = (state, hours) => {
  state.formDates.originHours = hours;
}

export const formDatesOriginMinutes = (state, minutes) => {
  state.formDates.originMinutes = minutes;
}

export const formDatesDestinationDate = (state, date) => {
  state.formDates.destinationDate = date;
}

export const formDatesDestinationHours = (state, hours) => {
  state.formDates.destinationHours = hours;
}

export const formDatesDestinationMinutes = (state, minutes) => {
  state.formDates.destinationMinutes = minutes;
}

export const formDatesPickUpDate = (state, date) => {
  state.formDates.pickUpDate = date;
}

export const formDatesPickUpHours = (state, hours) => {
  state.formDates.pickUpHours = hours;
}

export const formDatesPickUpMinutes = (state, minutes) => {
  state.formDates.pickUpMinutes = minutes;
}


export const infoFrom = (state, value) => {
  state.info.from = value;
}

export const infoTo = (state, value) => {
  state.info.to = value;
}

export const infoTripType = (state, value) => {
  state.info.tripType = value;
}

export const infoServiceType = (state, value) => {
  state.info.serviceType = value;
}

export const voucherToken = (state, token) => {
  state.voucherToken = token;
}

export const ecommerceTransaction = (state, transaction)  => {
  ecommerce.addTransaction(transaction);
  ecommerce.send();
}

export const phoneData = (state, data) => {
  state.phoneData = data;
}

export const setLoadPaypalScript = (state, value) => {
  state.loadPaypalScript = value;
}

function formatePlaceDetails(place) {
  const p = {
    gPlace: {
      ...place,
    },
    location: {
      lat: place.geometry.location.lat,
      lng: place.geometry.location.lng
    }
  }
  /* p.gPlace.address_components.forEach((a, i) => { */
  /*   delete a.types; */
  /* }); */
  /* delete p.gPlace.types; */
  return p;
}
